module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/mceltis14-0347803f505f778871a72324f170c7b5.jpg";